import { connect } from 'react-redux';
import LaporanHasilKI2 from '../../../../views/Kurikulum/Raport/Cetak/LaporanHasilKI2.view';
import { getStudent } from '../../../../states/thunks/student.thunk';


function mapDispatchToProps(dispatch) {
  return {
    handleGetStudent: () => dispatch(getStudent()),
  };
}
export default connect(null, mapDispatchToProps)(LaporanHasilKI2);
